/* HALO — Stable product return V10.
 * Purpose: prevent the hero/banner from flashing when returning via browser Back
 * from a product reached from a product carousel or catalog.
 * Loaded synchronously in <head> through snippets/halo_navigation_stable.liquid.
 * Does not touch Shopify cart, variant selection, or translations.
 */
(function () {
  'use strict';
  if (window.__haloNavigationV10) return;
  window.__haloNavigationV10 = true;

  var KEY = 'halo:return-origin:v10';
  var MAX_AGE = 20 * 60 * 1000;
  var root = document.documentElement;
  var outgoingToProduct = false;
  var origin = window.location.pathname + window.location.search;
  var startTime = Date.now();

  // The stylesheet is installed BEFORE the body paints on a fresh history return.
  // On BFCache returns the class is already set on the cached DOM at pagehide.
  var style = document.createElement('style');
  style.id = 'halo-nav-v10-style';
  style.textContent = 'html.halo-nav-return-cover body::after{' +
    'content:""!important;position:fixed!important;inset:0!important;' +
    'z-index:2147483647!important;display:block!important;' +
    'background:#F8F4EE!important;opacity:1!important;' +
    'pointer-events:auto!important;transition:none!important;' +
    'transform:none!important;animation:none!important;}' +
    'html.halo-nav-return-cover{scroll-behavior:auto!important;}' +
    'html.halo-nav-return-cover body{scroll-behavior:auto!important;}';
  (document.head || root).appendChild(style);

  function getState() {
    try {
      var state = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
      if (!state || !state.origin || !Number.isFinite(Number(state.time))) return null;
      if (Date.now() - Number(state.time) > MAX_AGE) return null;
      return state;
    } catch (_) { return null; }
  }
  function forget() {
    try { window.sessionStorage.removeItem(KEY); } catch (_) { /* storage not available */ }
  }
  function remember(state) {
    try { window.sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (_) { /* storage not available */ }
  }
  function navigationType() {
    try {
      var entry = performance.getEntriesByType('navigation')[0];
      return entry && entry.type || '';
    } catch (_) { return ''; }
  }
  function isProductPage(url) {
    return /\/products\/[^/]+/.test(url.pathname);
  }
  function shield() { root.classList.add('halo-nav-return-cover'); }
  function unshield() { root.classList.remove('halo-nav-return-cover'); }

  // On a new document produced by a browser Back action, the cover is inserted
  // synchronously in <head>, before the hero can be painted.
  var initialState = getState();
  if (initialState && initialState.origin === origin && navigationType() === 'back_forward') {
    shield();
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  }

  // Save the position ONLY when following a real product link, and preserve the
  // vertical relationship to the product carousel for layout-shift resilience.
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
    var target = event.target;
    if (!target || !target.closest) return;
    var link = target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (_) { return; }
    if (url.origin !== window.location.origin || !isProductPage(url) || isProductPage(window.location)) return;

    var section = link.closest('[id^="shopify-section-"]') || link.closest('[data-hfc-section]') || link.closest('section[id]');
    var track = section && section.querySelector('.hfc-track');
    var sectionId = section && section.id || '';
    var sectionTop = section ? section.getBoundingClientRect().top : 0;
    remember({
      origin: origin,
      time: Date.now(),
      y: Math.max(0, window.scrollY || window.pageYOffset || 0),
      sectionId: sectionId,
      sectionTop: sectionTop,
      carouselId: track && track.id || '',
      carouselLeft: track ? Math.max(0, track.scrollLeft) : null
    });
    outgoingToProduct = true;
  }, true);

  // This is the essential BFCache fix: the saved homepage is COVERED before the
  // browser freezes it, so Brave never paints its hero while restoring scroll.
  window.addEventListener('pagehide', function () {
    if (!outgoingToProduct) return;
    shield();
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  });

  function restoreTrack(state) {
    if (state.carouselLeft === null || !state.sectionId) return;
    var section = document.getElementById(state.sectionId);
    if (!section) return;
    var track = state.carouselId ? document.getElementById(state.carouselId) : section.querySelector('.hfc-track');
    if (!track) return;
    var priorBehavior = track.style.scrollBehavior;
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = Number(state.carouselLeft) || 0;
    // The inline style may be removed after painting. Do not start a smooth scroll.
    requestAnimationFrame(function () { track.style.scrollBehavior = priorBehavior; });
  }
  function desiredY(state) {
    var fallback = Math.max(0, Number(state.y) || 0);
    if (!state.sectionId) return fallback;
    var anchor = document.getElementById(state.sectionId);
    if (!anchor) return fallback;
    var absoluteTop = anchor.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
    return Math.max(0, Math.round(absoluteTop - (Number(state.sectionTop) || 0)));
  }
  function instantScroll(y) {
    var rootStyle = root.style.scrollBehavior;
    var bodyStyle = document.body ? document.body.style.scrollBehavior : '';
    root.style.scrollBehavior = 'auto';
    if (document.body) document.body.style.scrollBehavior = 'auto';
    try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); }
    catch (_) { window.scrollTo(0, y); }
    root.style.scrollBehavior = rootStyle;
    if (document.body) document.body.style.scrollBehavior = bodyStyle;
  }

  function restore(state) {
    shield();
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var frames = 0;
    var steady = 0;
    var lastTarget = -1;
    var lastScroll = -1;
    var finished = false;
    var watchdog;
    function finish() {
      if (finished) return;
      finished = true;
      if (watchdog) clearTimeout(watchdog);
      restoreTrack(state);
      unshield();
      forget();
      outgoingToProduct = false;
      if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
    }
    // Fail safely on an unexpected error/slow network; never leave the site covered.
    watchdog = setTimeout(finish, 1000);
    function frame() {
      if (finished) return;
      if (!document.body) { requestAnimationFrame(frame); return; }
      frames++;
      var y = desiredY(state);
      instantScroll(y);
      restoreTrack(state);
      var actual = window.scrollY || window.pageYOffset || 0;
      // Two stable frames ensure the browser has had time to lay out the hero
      // and the destination carousel before any homepage content is revealed.
      if (Math.abs(y - lastTarget) < 2 && Math.abs(actual - lastScroll) < 2 && Math.abs(y - actual) < 3) steady++;
      else steady = 0;
      lastTarget = y;
      lastScroll = actual;
      if ((steady >= 2 && frames >= 3) || frames >= 18) {
        finish();
      } else {
        requestAnimationFrame(frame);
      }
    }
    requestAnimationFrame(frame);
  }

  // pageshow runs both for BFCache restores (persisted=true) and full navigations.
  window.addEventListener('pageshow', function (event) {
    var state = getState();
    if (!state || state.origin !== origin) {
      unshield();
      outgoingToProduct = false;
      return;
    }
    var back = !!(event && event.persisted) || navigationType() === 'back_forward';
    // A BFCache document may retain the cover from pagehide even when the
    // performance entry still describes its first navigation.
    if (!back && !root.classList.contains('halo-nav-return-cover')) return;
    restore(state);
  });

  // Shopify editor may update parts of the document without a true page load.
  // Never carry the cover into theme customization preview interactions.
  document.addEventListener('shopify:section:load', function () {
    if (window.Shopify && window.Shopify.designMode) { unshield(); forget(); }
  });
})();